module.exports = __webpack_public_path__ + "img/2.579cf599.jpg";